/**
 * Query parameters the federation launch endpoint redirects with. Owned by that endpoint, so the
 * names mirror its redirect rather than any convention of this app.
 */
export const LaunchQueryParams = {
    CODE: 'code',
    BASE_URL: 'base_url',
    USERNAME: 'username',
    ERROR: 'error',
} as const;

/**
 * Why a launch could not sign the user in. The first four mirror the reasons the federation launch
 * endpoint reports; ExchangeFailed is this page's own, for a redirect that arrived incomplete or a
 * launch code the API refused to exchange.
 */
export const LaunchFailure = {
    SessionInvalid: 'session_invalid',
    NoBranch: 'no_branch',
    NotPermitted: 'not_permitted',
    Unavailable: 'unavailable',
    ExchangeFailed: 'exchange_failed',
} as const;

export type LaunchFailure = (typeof LaunchFailure)[keyof typeof LaunchFailure];

const REPORTED_FAILURES: readonly string[] = [
    LaunchFailure.SessionInvalid,
    LaunchFailure.NoBranch,
    LaunchFailure.NotPermitted,
    LaunchFailure.Unavailable,
];

/**
 * Maps a reason taken from the url to a known failure. The url can be edited by anyone, so an
 * unrecognised value falls back to the generic message rather than being trusted.
 */
export function toLaunchFailure(reason: string): LaunchFailure {
    if (REPORTED_FAILURES.includes(reason)) {
        return reason as LaunchFailure;
    }

    return LaunchFailure.ExchangeFailed;
}
